
import Hero from "../Components/FirstComponents/Hero";
import AboutHypertension from "../Components/FirstComponents/AboutHypertension";
import RiskFactor from "../Components/FirstComponents/RiskFactor";
import OrganAffected from "../Components/FirstComponents/OrganAffected";
import HypertensionFact from "../Components/FirstComponents/HypertensionFact";
import HypertensionVideo from "../Components/FirstComponents/HypertensionVideo";
import DoctorView from "../Components/FirstComponents/DoctorView";
import PatientsView from "../Components/FirstComponents/PatientsView";
import Subscribe from "../Components/FirstComponents/Subscribe";

function FirstLanding() {
  return (
    <>
      <div
        className="bg-gray-200 bg-no-repeat bg-contain "
        style={{
          backgroundImage: "url('/assets/background.png')",
          backgroundPosition: "right top",
        }}
      >
        <div className="mx-auto ">
          <Hero />
          <AboutHypertension />
          <RiskFactor />
          <OrganAffected />
          <HypertensionFact />
          <HypertensionVideo />
          <DoctorView />
          <PatientsView />
          <Subscribe />
        </div>
      </div>
    </>
  );
}

export default FirstLanding;
